import { isUndefined } from '@aloft/toolkit-shared';
import { Flex, SimpleInput, SimpleTextArea } from '@aloft/toolkit-sui';

import { Controller, useFormState } from 'react-hook-form';

import { useZodFormContext } from '../../hooks/useZodForm.js';
import { PairedSalesFormSchema } from './types.js';

export const ReconciliationForm = () => {
  const { register, control } = useZodFormContext<PairedSalesFormSchema>();

  const errors = useFormState({ control }).errors;

  return (
    <Flex gap="20px" flexDirection="column">
      <Controller
        name="reconciledValue"
        control={control}
        render={({ field }) => (
          <SimpleInput
            {...field}
            id="reconciledValue"
            label="Reconciled Value"
            variant="outline"
            type="number"
            size="sm"
            invalid={!isUndefined(errors.reconciledValue)}
            errorMessage={errors.reconciledValue?.message}
            precision={2}
            prefix="$"
            useSeparator
          />
        )}
      />

      <SimpleTextArea {...register('notes')} id="commentary" size="lg" label="Commentary" />
    </Flex>
  );
};
